<form class="mc-vertical-split-dialog mc-spring-board" [formGroup]="reviewPackageResolveChangesDialogForm" (ngSubmit)="onSubmit()">
  <div matDialogTitle class="mc-spring-board-header">
    <mat-icon fontSet="project-titan" fontIcon="icon-alert" class="mc-image-icon mc-image-icon-normal" color="primary"></mat-icon>
    <button type="button" mat-icon-button class="mc-vertical-split-dialog-close-button" tabindex="-1" (click)="closeDialog()">
      <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
    </button>
  </div>

  <div class="mc-spring-board-form-body">
    <h2 class="mc-vertical-split-dialog-title">Unresolved track changes</h2>
    <mat-accordion *ngIf="unresolvedFileNames?.length" class="accordion-flat mc-accordion-list" displayMode="flat" togglePosition="before">
      <mat-expansion-panel class="mc-review-package-resolve-changes-dialog-files" [expanded]="true">
        <mat-expansion-panel-header class="mc-review-package-resolve-changes-dialog-files-header" collapsedHeight="3rem" expandedHeight="3rem">
          <mat-panel-title>
            {{unresolvedFileNames.length}} {{unresolvedFileNames.length > 1 ? 'Files' : 'File'}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          <li *ngFor="let name of unresolvedFileNames">{{name}}</li>
        </ul>
      </mat-expansion-panel>
    </mat-accordion>

    <p class="mc-form-text">These files contain unresolved track-changes.</p>
    <p class="mc-form-text">Cancel to accept/reject the changes, or choose an option below to decide how to handle them.</p>

    <mat-radio-group class="mc-review-package-resolve-changes-dialog-action" formControlName="action" aria-label="Select an option">
      <mat-radio-button [value]="ReviewPackageResolveChangesOption.Transfer">Transfer unresolved changes</mat-radio-button>
      <mat-radio-button [value]="ReviewPackageResolveChangesOption.Accept">Accept all changes</mat-radio-button>
      <mat-radio-button [value]="ReviewPackageResolveChangesOption.Reject">Reject all changes</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="mc-spring-board-form-footer">
    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="closeDialog()">Cancel</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="!reviewPackageResolveChangesDialogForm.valid">Continue</button>
    </div>
  </div>
</form>